export default __webpack_public_path__ + "static/media/success.2b1900ca.png";